import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function CommunitypageBanner() {

  const [CommunityBanner, setCommunityBanner] = useState({});

  useEffect(() => {
    const fetchCommunityBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/communities/banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setCommunityBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCommunityBanner();
  }, []);

  return (
    <div
      className="common-banner-sec common-flex-center community-page-banner"
      style={{
        backgroundImage: `url(${apiUrl.apiUrl + `/` + CommunityBanner.banner_image
          })`,
      }}
    >
      <div className="overlay"></div>
      <Container fluid>
        <Row className="common-flex-center">
          <Col md={8}>
            <div className=" ">
              <h1 className="common-head whiteColor">
                {CommunityBanner.banner_title}
              </h1>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CommunitypageBanner;
